import { render, staticRenderFns } from "./LessonStandaloneView.vue?vue&type=template&id=3d18b2cf"
import script from "./LessonStandaloneView.vue?vue&type=script&lang=js"
export * from "./LessonStandaloneView.vue?vue&type=script&lang=js"
import style0 from "./LessonStandaloneView.vue?vue&type=style&index=0&id=3d18b2cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports